(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/accountservices-react/deposit/assets/dialogs/block-info-dialogs.js') >= 0) return;  svs.modules.push('/components/accountservices-react/deposit/assets/dialogs/block-info-dialogs.js');

'use strict';

const showSetDepositTimesDialog = title => new Promise(resolve => {
  const dialog = new svs.ui.dialog.Confirm({
    icon: 'my-settings',
    branding: svs.ui.dialog.branding.TUR,
    area: svs.ui.dialog.area.POPUP,
    title,
    actions: [{
      title: 'Avbryt',
      callback() {
        dialog.close();
        resolve(false);
      }
    }, {
      title: 'Fortsätt',
      callback() {
        dialog.close();
        resolve(true);
      }
    }]
  });
  svs.ui.dialog.api.add(dialog);
});
const showSetDepositTimesSucessDialog = title => new Promise(resolve => {
  const dialog = new svs.ui.dialog.Confirm({
    icon: 'my-settings',
    branding: svs.ui.dialog.branding.TUR,
    area: svs.ui.dialog.area.POPUP,
    title,
    actions: [{
      title: 'Okej',
      callback() {
        dialog.close();
        resolve(true);
      }
    }]
  });
  svs.ui.dialog.api.add(dialog);
});
const generalErrorDialog = () => {
  const dialog = new svs.components.dialog.Confirm({
    branding: svs.components.dialog.branding.TUR,
    icon: 'exclamation-sign',
    type: svs.components.dialog.type.ERROR,
    title: 'Tekniskt fel',
    message: [{
      type: svs.components.dialog.message.TEXT,
      text: 'Tekniskt fel, var god försök senare.'
    }],
    actions: [{
      type: svs.components.dialog.button.SECONDARY,
      showLoader: true,
      title: 'Okej',
      callback() {
        dialog.close();
      }
    }]
  });
  svs.ui.dialog.api.add(dialog);
};
svs.accountservicesReact.deposit.dialogs.blockInfoDialogs = {
  showSetDepositTimesDialog,
  showSetDepositTimesSucessDialog,
  generalErrorDialog
};

 })(window);